var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bootstrapLoaded && _vm.clientId)?_c('DataCaptureClientMaintenance',{attrs:{"clientId":_vm.clientId,"navigation":_vm.navigation,"requiresChangeRequest":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }